import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_employees_not_in_tenant_module_data: { message: "idle" },
};

export const retrieve_employees_not_in_tenant_module_data_Slice = createSlice({
 name: "retrieve_employees_not_in_tenant_module_data",
 initialState,
 reducers: {
  success_retrieve_employees_not_in_tenant_module_data: (state, action) => {
   state.retrieve_employees_not_in_tenant_module_data = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_employees_not_in_tenant_module_data: (state, action) => {
   state.retrieve_employees_not_in_tenant_module_data = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_employees_not_in_tenant_module_data: (state) => {
   state.retrieve_employees_not_in_tenant_module_data = { status: app_consts.IDLE };
  },
  loading_retrieve_employees_not_in_tenant_module_data: (state) => {
   state.retrieve_employees_not_in_tenant_module_data = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_employees_not_in_tenant_module_data, fail_retrieve_employees_not_in_tenant_module_data, reset_retrieve_employees_not_in_tenant_module_data, loading_retrieve_employees_not_in_tenant_module_data } = retrieve_employees_not_in_tenant_module_data_Slice.actions;

export default retrieve_employees_not_in_tenant_module_data_Slice.reducer;